import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { useAuthenticatedImage } from 'src/hooks/useAuthenticatedImage';


const useStyles = makeStyles(theme => ({
  imageContainer: props => ({
    backgroundColor: theme.palette.common.gray400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
    width: props.width,
    height: props.height,
  }),
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  placeholder: {
    padding: theme.spacing(1),
    color: theme.palette.common.gray600,
    textAlign: 'center',
    fontSize: '0.75rem',
  },
}));

const AuthenticatedImage = props => {
  const { url, alt, width = 120, height = 120, className, errorMessage = 'Error al cargar', ...otherProps } = props;
  const classes = useStyles({ width, height });
  const { imageUrl, isLoading, hasError } = useAuthenticatedImage({ url });
  const containerClassName = `${classes.imageContainer} ${className || ''}`;

  return (
    <Box className={containerClassName}>
      {!url ?
        <Typography variant="body2" className={classes.placeholder}>
          Vista previa no disponible
        </Typography>
        : isLoading ?
          <Skeleton animation='wave' variant="rect" width={width} height={height} />
          : hasError || !imageUrl ?
            <Typography variant="body2" className={classes.placeholder}>
              {errorMessage}
            </Typography>
            :
            <img src={imageUrl} alt={alt} className={classes.image} {...otherProps} />
      }
    </Box>
  );
};

AuthenticatedImage.propTypes = {
  url: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
};


export { AuthenticatedImage };